import React from 'react';
import { Shapes } from 'lucide-react';
import { routesOutside } from '../../company/routeTable';

/**
 * Mimesa's navigation: an explicit allowlist of base screens (nav keys). Anything not listed
 * is not in the sidebar, the command palette or the router, and its URL sends the user home.
 * No reports beyond the ones listed, nothing auditor-related.
 *
 * Mimesa's own screens (e.g. its future reports in ./reports) are added through `extraNav`
 * here and `extraRoutes` in ./index.js.
 */
export const MIMESA_SCREENS = Object.freeze([
    'dashboard',
    'notifications',
    'clients',
    // The client role's own company profile (its fixed menu); same page as a client's detail.
    'my-client',
    'stores',
    'users',
    'promoters',
    'promoters-analytics',
    'products',
    // Mimesa's own screen (./pages/categories, registered in ./index.js).
    'categories',
    'segments',
    'tags',
    'price',
    'campaigns',
    'contracts',
    // Encuestas: shown only while the polls flag is on (see ./features.js).
    'polls',
    'activity-logs',
    'permissions',
]);

const MIMESA_NAVIGATION = Object.freeze({
    screens: MIMESA_SCREENS,
    // Sidebar / palette items for Mimesa's own routes: { key, label, icon, href, description, after? }.
    extraNav: Object.freeze([
        {
            key: 'categories',
            label: 'Categorías',
            description: 'Categorías del catálogo de productos',
            icon: <Shapes />,
            href: '/dashboard/products/categories',
            after: 'products',
        },
    ]),
});

/** Base routes Mimesa does not mount: everything outside the allowlist. */
export const MIMESA_REMOVED_ROUTES = Object.freeze(routesOutside(MIMESA_SCREENS));

export default MIMESA_NAVIGATION;
